import { module } from 'angular';

import { default as indicatorListName, IndicatorList } from './indicator-list.component.ajs';

export default module('hypervision.synthetic-view.indicator-list', []).component(indicatorListName, new IndicatorList()).name;
